/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store.js";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/site",
          redirect: "/site/1",
        },
        {
          path: "/site/graph",
          redirect: "/site/graph/1",
        },
        {
          path: "/camera",
          redirect: "/camera/all",
        },
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Dashboard",
            breadcrumb: [{ title: "Dashboard", active: true }],
          },
        },
        {
          path: "/site/:slug",
          name: "sites",
          component: () => import("./views/Site.vue"),
        },
        {
          path: "/site/graph/:slug",
          name: "site-graph",
          component: () => import("./views/SiteGraph.vue"),
        },
        {
          path: "/site/graph/:slug/:id",
          name: "site-graph-detail",
          component: () => import("./views/SiteGraph.vue"),
        },
        {
          path: "/site/:slug/:id",
          name: "area",
          component: () => import("./views/ListCamera.vue"),
        },
        {
          path: "/camera/all",
          name: "camera",
          component: () => import("./views/AllCamera.vue"),
        },
        {
          path: "/camera_preview/:id",
          name: "camera_preview",
          component: () => import("./views/PreviewCamera.vue"),
        },
        {
          path: "/site_settings",
          name: "site_settings",
          component: () => import("./views/configurations/SiteSettings.vue"),
          meta: {
            //authRequired: true,
            pageTitle: "Site Settings",
          },
        },
        {
          path: "/org_management",
          name: "org_management",
          component: () => import("./views/configurations/OrgManagement.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Company Management",
          },
        },
        {
          path: "/org_management/sites",
          name: "org_management_sites",
          component: () => import("./views/configurations/orgs/sites"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Sites Management",
          },
        },
        {
          path: "/org_management/area",
          name: "org_management_area",
          component: () => import("./views/configurations/orgs/areas"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Area Management",
          },
        },
        {
          path: "/org_management/cameras",
          name: "org_management_cameras",
          component: () => import("./views/configurations/orgs/cameras"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Camera Management",
          },
        },
        {
          path: "/org_management/users",
          name: "org_management_users",
          component: () => import("./views/configurations/orgs/users"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "User Management",
          },
        },
        {
          path: "/org_management/update_user/:id",
          name: "org_management_users_update",
          component: () => import("./views/configurations/orgs/users/form.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Update User",
          },
        },
        {
          path: "/org_management/embed_access/:id",
          name: "org_management_embed_access",
          component: () => import("./views/configurations/orgs/users/formEmbed.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Embed Link Access",
          },
        },
        {
          path: "/org_management/general",
          name: "org_management_general",
          component: () => import("./views/configurations/orgs/general"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "General Management",
          },
        },
        {
          path: "/org_management/add_company",
          name: "org_management_add_company",
          component: () =>
            import("./views/configurations/orgs/company/add.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Add Company",
          },
        },
        {
          path: "/org_management/update_company/:id",
          name: "org_management_update_company",
          component: () =>
            import("./views/configurations/orgs/company/add.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Update Company",
          },
        },
        {
          path: "/org_management/add_sites",
          name: "org_management_add_sites",
          component: () => import("./views/configurations/orgs/sites/add.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Add Sites",
          },
        },
        {
          path: "/org_management/update_sites/:id",
          name: "org_management_update_sites",
          component: () => import("./views/configurations/orgs/sites/add.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Update Sites",
          },
        },
        {
          path: "/org_management/add_area",
          name: "org_management_add_area",
          component: () => import("./views/configurations/orgs/areas/add.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Add Area",
          },
        },
        {
          path: "/org_management/update_area/:id",
          name: "org_management_update_area",
          component: () => import("./views/configurations/orgs/areas/add.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Update Area",
          },
        },
        {
          path: "/org_management/update_camera",
          name: "org_management_update_camera",
          component: () =>
            import("./views/configurations/orgs/cameras/form.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Cameras",
          },
        },
        {
          path: "/org_management/users_add",
          name: "org_management_users_add",
          component: () => import("./views/configurations/orgs/users/form.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Users",
          },
        },
        {
          path: "/custom_report",
          name: "custom_report",
          component: () => import("./views/custom_report/index.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Custom Reports",
          },
        },
        {
          path: "/custom_report/add",
          name: "custom_report_add",
          component: () => import("./views/custom_report/form.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Add Custom Reports",
          },
        },
        {
          path: "/custom_report/:id/edit",
          name: "custom_report_edit",
          component: () => import("./views/custom_report/form.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Edit Custom Reports",
          },
        },
        {
          path: "/custom_report/:id",
          name: "custom_report_view",
          component: () => import("./views/custom_report/detail.vue"),
          meta: {
            authRequired: true,
          },
        },
        {
          path: "/custom_report/area/:id",
          name: "custom_report_area",
          component: () => import("./views/custom_report/detail.vue"),
          meta: {
            authRequired: true,
          },
        },
        {
          path: "/custom_report/camera/:id",
          name: "custom_report_camera",
          component: () => import("./views/custom_report/detail.vue"),
          meta: {
            authRequired: true,
          },
        },
        {
          path: "/reports",
          name: "reports_new",
          component: () => import("./views/reports/new.vue"),
          meta: {
            authRequired: true,
          },
        },
        {
          path: "/reports/area/:id",
          name: "reports_area_new",
          component: () => import("./views/reports/new.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Area Reports",
          },
        },
        {
          path: "/reports/camera/:id",
          name: "reports_camera_new",
          component: () => import("./views/reports/new.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Camera Reports",
          },
        },
        {
          path: "/report_occupancy",
          name: "report_occupancy",
          component: () => import("./views/reports/sub_new.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Reports",
          },
        },
        {
          path: "/report_occupancy",
          name: "report_occupancy",
          component: () => import("./views/reports/sub_new.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Reports",
          },
        },
        {
          path: "/report_occupancy/area/:id",
          name: "report_occupancy_area",
          component: () => import("./views/reports/sub_new.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Area Reports",
          },
        },
        {
          path: "/report_occupancy/camera/:id",
          name: "report_occupancy_camera",
          component: () => import("./views/reports/sub_new.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Camera Reports",
          },
        },
        // {
        //   path: "/report_old",
        //   name: "reports_index",
        //   component: () => import("./views/reports/sub.vue"),
        //   meta: {
        //     authRequired: true,
        //     pageTitle: "Reports",
        //   },
        // },
        // {
        //   path: "/report_old/site/:id",
        //   name: "reports_site",
        //   component: () => import("./views/reports/sub.vue"),
        //   meta: {
        //     authRequired: true,
        //     pageTitle: "Site Reports",
        //   },
        // },
        // {
        //   path: "/report_old/area/:id",
        //   name: "reports_area",
        //   component: () => import("./views/reports/sub.vue"),
        //   meta: {
        //     authRequired: true,
        //     pageTitle: "Area Reports",
        //   },
        // },
        // {
        //   path: "/report_old/camera/:id",
        //   name: "reports_camera",
        //   component: () => import("./views/reports/sub.vue"),
        //   meta: {
        //     authRequired: true,
        //     pageTitle: "Camera Reports",
        //   },
        // },
        {
          path: "/bookmark",
          name: "bookmark_index",
          component: () => import("./views/bookmark/index.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Bookmark",
          },
        },
        {
          path: "/bookmark/:id",
          name: "bookmark_show",
          component: () => import("./views/bookmark/show.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Bookmark",
          },
        },
        {
          path: "/pages/logout",
          name: "pages_logout",
          component: () => import("./views/pages/Logout.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Logout",
          },
        },
        // Views Cameras
        {
          path: "/views",
          name: "page_views",
          component: () => import("./views/views/index.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Views",
          },
        },
        {
          path: "/help",
          name: "help_index",
          component: () => import("./views/Help.vue"),
          meta: {
            authRequired: true,
            pageTitle: "Help",
          },
        },
        {
          path: "/org_management/site_cameralists",
          name: "org_management_site_cameralists",
          component: () => import("./views/configurations/orgs/sites/list_cameras"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Sites Cameras",
          },
        },
        {
          path: "/alarm",
          name: "alarm",
          component: () => import("./views/alarm/index.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Event Alarms",
          },
        },
        {
          path: "/alarm/:id",
          name: "alarm/:id",
          component: () => import("./views/alarm/detail.vue"),
          meta: {
            authRequired: true,
            role: "admin",
            pageTitle: "Alarms Detail",
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem("accessToken");
  if (to.meta.authRequired) {
    if (accessToken != null) {
      if (to.meta.role && to.meta.role == "admin") {
        const userInfo = store.getters.getActiveUser;
        if (userInfo && userInfo.roleName.toLowerCase() == "admin") {
          next();
        } else {
          next({ path: "/reports" });
        }
      } else {
        next();
      }
    } else {
      next({ path: "/pages/login", query: { to: to.path, id: to.query.id } });
    }
  } else {
    next();
  }
});

export default router;
